mutation ApprovalTestGroupDelete($input: ApprovalTestGroupDeleteInput!) {
  approvalTestGroupDelete(input: $input) {
    entityDeletes {
      id
      rowTimestamp
    }
    query {
      approvalTestGroups(orderBy: NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          name
          description
          approvalTestItems {
            nodes {
              id
            }
          }
        }
        totalCount
      }
    }
  }
}
